module.exports = __webpack_public_path__ + "static/media/354.75912438.webp";